export enum ResultStatus {
    // 200 (Verification required, go to verification step)
    SmsSent = 'SmsSent',
    // 200 (No verification required, skip verification step)
    Whitelisted = 'Whitelisted',
    NoFurtherValidationNeeded = 'NoFurtherValidationNeeded',
    ServiceUnavailable = 'ServiceUnavailable',
    NotAMobilePhoneNumber = 'NotAMobilePhoneNumber', // Verification required, go to verification step to edit phone number
    // 400 (Bad request)
    Blacklisted = 'blacklisted',
    UnsupportedCountryCode = 'UnsupportedCountryCode',
    UserOptedOut = 'UserOptedOut', // would be used in case we switch back to the v1
    WrongPhoneNumberFormat = 'WrongPhoneNumberFormat',
    Conflict = 'conflict', // sms already sent and code still valid
    // 500 (Internal server error)
    UnexpectedError = 'UnexpectedError',
}

export enum ValidationMethods {
    SmsCode = 'SmsCode',
    Whitelisted = 'Whitelisted',
    RegexOnly = 'RegexOnly',
    UnableToVerifyAtCreation = 'UnableToVerifyAtCreation',
}

export enum SmsServiceCode {
    VerificationRetryCountExceeded = 'verificationRetryCountExceeded',
    ExpiredCode = 'expiredCode',
    CodeMismatch = 'codeMismatch',
    VerificationCodeSent = 'verificationCodeSent',
    VerificationCodeServerError = 'verificationCodeServerError',
}

/* An external service is used for the phone number verification by sending a code via SMS.
This sms is valid for 180 seconds on v2 */
export const CountdownInSeconds = 180;
